









































































































import _ from 'lodash'
import moment from 'moment'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Action, State, Mutation } from 'vuex-class'
import { MediaObject } from '@/modules/media/types'
import UploadManager from '@/modules/media/components/UploadManager.vue'
import MediaViewer from '@/modules/media/components/MediaViewer.vue'
import DeleteSelectionConfirm from '@/modules/media/components/DeleteSelectionConfirm.vue'
import MediaLibraryItem from '@/modules/media/components/MediaLibraryItem.vue'
import DragSelect from 'vue-drag-select/src/DragSelect.vue'
import draggable from 'vuedraggable'
import {MediaListFilters as Filters} from '@/modules/media/api'
import {Watch} from 'vue-property-decorator';
import LoadingScreen from '@/modules/core/LoadingScreen'
import MediaListFilters from '@/modules/media/components/MediaListFilters.vue'
import Loader from '@/components/Loader.vue';

/**
 * Librería multimedia
 *
 * Permite al usuario administrar los archivos de la aplicación
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        Loader,
        MediaListFilters,
        MediaLibraryItem,
        'upload-manager': UploadManager,
        'media-viewer': MediaViewer,
        'delete-selection-confirm': DeleteSelectionConfirm,
        DragSelect,
    },
})
export default class MediaLibrary extends Vue {

    public $refs: Vue['$refs'] & {
        mediaItem: Array<{id: string}>,
    }

    /**
     * Lista de objetos multimedia cargados en el estado de la aplicación
     */
    @State(state => state.media.objects)
    public media: MediaObject[]

    /**
     * Indica si se encuentra activa la pantalla que muestra el administrador
     * de subidas de archivos
     */
    @State(state => state.media.showUploadManager)
    public uploadManagerVisibility: boolean

    /**
     * Lista con los ids de los elementos seleccionados por el usuario
     */
    @State(state => state.media.selectedObjects)
    public selectedObjects: number[]

    /**
     * Mutación del store de la aplicación que activa o desactiva el administrador
     * de subidas
     */
    @Mutation('media/uploadManager/show')
    public showUploadManager: (show: boolean) => void

    /**
     * Mutación que establece el objeto multimedia actualmente en visualización/edición
     * por el usuario
     */
    @Mutation('media/objects/current/set')
    public setCurrentMediaObject: (media: MediaObject) => void

    /**
     * Mutación que establece la lista de ids de los objetos elementos seleccionados
     * por el usuario
     */
    @Mutation('media/SET_SELECTED_OBJECTS')
    public setObjectSelection: (objects: number[]) => void

    /**
     * Mutación que activa o desactiva la pantalla de confirmación para eliminar
     * archivos
     */
    @Mutation('media/selection/delete/confirm/show')
    public showDeleteSelectionConfirm: (show: boolean) => void

    /**
     * Carga en el estado de la aplicación una lista de elementos
     */
    @Action('media/objects/load')
    public loadLibrary: (filter: Filters) => MediaObject[]

    public get fullscreen () {
        return this.$vuetify.breakpoint.smAndDown
    }

    /**
     * Tipos de contenidos que el usuario puede utilizar para filtrar
     */
    public types = [
        { type: 'video', name: 'Videos', icon: 'mdi-video'},
        { type: 'image', name: 'Imágenes', icon: 'photo'},
        { type: 'application/pdf', name: 'Archivos PDF', icon: 'mdi-file-pdf-box'},
        { type: '', name: 'Todos', icon: 'mdi-file'},
    ]

    /**
     * Cabeceras de la tabla de archivos
     */
    public headers = [
        { text: 'Título', value: 'title'},
        { text: 'Creador', value: 'creator.name'},
        { text: 'Fecha de creación', value: 'createdAt'},
        { text: 'Ultima modificación', value: 'updatedAt'},
        { text: 'Tamaño archivo', value: 'size'},
    ]

    public grid = true
    public selected = []
    public loading = true
    public multiselect = false
    public listFilters = new Filters()
    public reloading = false
    public filtersDetail = false

    /**
     * Observa los filtros para la lista de objetos multimedia, si cambian se
     * solicita a la API una lista con el nuevo criterio
     *
     * @param val
     */
    @Watch('listFilters', {deep: true})
    public async listFilterChange (val: Filters) {
        this.reloading = true
        // Limpia la selección de objetos
        this.setObjectSelection([])
        await this.loadLibrary(val)
        this.reloading = false
    }

    get selection (): number[] {
        return this.selectedObjects
    }

    public computeGridSelection = _.throttle(function (this: MediaLibrary, objects: Array<{mediaId: number}>) {
        this.setObjectSelection(objects.map(o => o.mediaId))
    }, 100)

    /**
     * Al crear el componente solicita una lista inicial de los archivos
     */
    public async created () {
        await this.loadLibrary(this.listFilters)
        this.loading = false
    }

    public onKeydown (event: KeyboardEvent) {
        this.multiselect = event.key === 'Control'
        if (event.key === 'Delete' && this.selectedObjects.length > 0) {
            this.showDeleteSelectionConfirm(true)
        }
    }

    public onKeyup (event: KeyboardEvent) {
        if (event.key === 'Control') {
           this.multiselect = false
        }
    }

    public mounted () {
        // Evento de teclado para controlar la selección múltiple de elementos y el botón suprimir
        document.addEventListener('keydown', this.onKeydown)
        document.addEventListener('keyup', this.onKeyup)
    }

    public destroy () {
        document.removeEventListener('keydown', this.onKeydown)
        document.removeEventListener('keyup', this.onKeyup)
    }
}
